export default "__VITE_ASSET__BS1YqDC4__"